import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useHreflang } from "../../i18n/hooks/useHreflang";
import { getLocaleFromPath, localePath } from "../../i18n/config";
import { metadataTranslations } from "../../i18n/metadata";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Button from "../../components/button/Button";
import Banner from "../../components/layout/banner/Banner";
import { getAlertsRequest } from "../../redux/actions";
import { AppState } from "../../redux/types";
import { classNames } from "../../utils/classnames";
import { ServicesType } from "../phone/Phone";
import styles from "./watch.module.css";

const Watch = () => {
    const hreflang = useHreflang("turvaranneke");
    const dispatch = useDispatch();
    const locale = getLocaleFromPath();
    const meta = metadataTranslations.watch[locale] || metadataTranslations.watch.fi;

    const currentDate = Date.now();

    useEffect(() => {
        dispatch(getAlertsRequest());
        return () => {};
    }, [dispatch]);

    const resources = useSelector((state: AppState) => state.alerts);
    const { list } = resources;

    const services: ServicesType[] = [
        {
            content: (
                <>
                    <div className="services-info-title">Paikantava Posifon turvaranneke</div>
                    <ul className="services-info-text">
                        <li>Hälytys napin painalluksella läheisten kännyköihin tai 112</li>
                        <li>Kaksisuuntainen puheyhteys </li>
                        <li>Gps 4G paikannus</li>
                        <li>Kaatumis- alue-ja akkuhälytys</li>
                        <li>
                            <a href="https://www.posifon.care/" className="global-link" target="_blank" rel="noreferrer">
                                Ruotsin suosituin
                            </a>{" "}
                            paikantava turvahälytin, tuhansia käyttäjiä
                        </li>
                        <li>Vesitiivis IP67</li>
                        <li>Digihappy takaisinostaa hyväkuntoisen alle 6 kk käytössä olleen laitteen</li>
                    </ul>
                </>
            ),
            image: "/assets/images/watch/Posifon_alarm.png",
            alt: "Musta turvaranneke seniorin ranteessa",
            contain: true,
        },
        {
            content: (
                <>
                    <div className="services-info-title">Paikantava Posifon kelloranneke UUSI</div>
                    <ul className="services-info-text">
                        <li>Tyylikäs älykello</li>
                        <li>Kaikki turva kuten turvarannekkeessa </li>
                        <li>Hälytys, 2-suuntainen puhe, paikannus</li>
                        <li>Kaatumis- alue- akkuhälytys</li>
                        <li>Vesitiivis IP67 </li>
                        <li>Askelmittaus </li>
                        <li>Näytön ulkonäkö valittavissa</li>
                    </ul>
                </>
            ),
            image: "/assets/images/watch/New_watch.png",
            alt: "Musta turvaranneke seniorin ranteessa",
            contain: true,
        },
        {
            content: (
                <>
                    <div className="services-info-title">Luotettavat turvahälytykset</div>
                    <ul className="services-info-text">
                        <li>Seniori hälyttää apua napin painalluksella</li>
                        <li>Hälytyssoitto menee läheisten kännyköihin tai 112</li>
                        <li>Kaksisuuntainen puheyhteys aukeaa heti</li>
                        <li>Paikannus läheisen kännykkäapilla</li>
                        <li>Automaattihälytykset kun seniori poistuu alueelta, kaatuu tai akku loppuu</li>
                    </ul>
                </>
            ),
            image: "/assets/images/watch/turvaranneke-seniorille-kaulamalli.webp",
            alt: "Käsi pitelee kaulamalli-turvahälytintä",
        },
        {
            content: (
                <>
                    <div className="services-info-title">Liittymä</div>
                    <ul className="services-info-text">
                        <li>Liittymä on Digihappylta ja valmiina laitteessa.</li>
                        <li>Hälytykset, paikannus ja puheyhteys toimivat liittymän ansiosta kaikkialla.</li>
                        <li>Laitteen toiminta EI ole sidottu seniorin kännykkään.</li>
                    </ul>
                </>
            ),
            image: "/assets/images/watch/paras-senioriturvaranneke.jpg",
            alt: "Valkoinen kissa nauttii vanhemman henkilön silittelystä, henkilöllä on turvahälytin ranteessaan",
            credit: "BILD: : Björn Johansson/Posifon",
        },
        {
            content: (
                <>
                    <div className="services-info-title">Appi, hallintapaneeli, aloitusneuvonta ja it-tuki läheisille</div>
                    <ul className="services-info-text">
                        <li>Helppo kännykkäappi</li>
                        <li>
                            Lisäksi ammattitason hallintapaneeli, jossa mm.
                            <ul>
                                <li>Hälytysten vastaanottajat, järjestys, kesto, kellonajat</li>
                                <li>Painalluksen pituus, äänivolyymit</li>
                                <li>Kaatumishälytyksen herkkyys</li>
                                <li>Turva-alueen rajaus</li>
                            </ul>
                        </li>
                        <li>Aloitusneuvonnan avulla helppo käyttööotto, teemme kaiken kanssasi</li>
                        <li>Suomalainen, kehuttu it-tuki ja laitehallinta</li>
                    </ul>
                </>
            ),
            image: "/assets/images/watch/helppo-senioripuhelin.webp",
            alt: "Mies, jolla on silmälasit ja parta, katsoo puhelintaan.",
        },
        {
            content: (
                <>
                    <div className="services-info-title">Akku ja lataus</div>
                    <ul className="services-info-text">
                        <li>
                            Posifon Turvaranneke on aidosti kuin "kännykkä ranteessa”
                            <ul>
                                <li>Kaikkialla toimiva kahdensuuntainen puhe, hälytys, kaatumishälytys ja paikannus</li>
                            </ul>
                        </li>
                        <li>
                            Akun kesto on laajoilla ominaisuuksilla yleensä 3-5 vrk
                            <ul>
                                <li>Huomioi, että ilmoitamme akun keston laajoilla ominaisuuksilla</li>
                                <li>Laite on aktiivinen aina</li>
                                <li>Kahdensuuntainen puheyhteys on aina</li>
                                <li>Laite paikantaa halutulla tiheydellä, mikä vaikuttaa akun kestoon</li>
                            </ul>
                        </li>
                        <li>
                            Akun matala varaus on turvallisesti hallittu
                            <ul>
                                <li>Laite puhuu seniorille suomeksi tai ruotsiksi "Lataa akku"</li>
                                <li>Läheisille tulee kännykkään “Matala varaus” -ilmoitus</li>
                            </ul>
                        </li>
                        <li>Laite toimii myös latautuessaan</li>
                    </ul>
                </>
            ),
            image: "/assets/images/watch/New_photo.png",
            alt: "Mies, jolla on silmälasit ja parta, katsoo puhelintaan.",
        },
    ];

    const [play, setPlay] = useState(0);
    return (
        <>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <link rel="alternate" hrefLang="fi" href={hreflang.fi} />
                <link rel="alternate" hrefLang="en" href={hreflang.en} />
                <link rel="alternate" hrefLang="sv" href={hreflang.sv} />
                <link rel="alternate" hrefLang="x-default" href={hreflang.fi} />
            </Helmet>
            <Banner
                backgroundImage="/assets/images/banners/turvaranneke-senorille.jpg"
                label="Iäkäs nainen vilkaisee rannekelloaan ollessaan ulkona puistossa"
                height={`calc(100vh - ${
                    56 +
                    56 *
                        list?.filter((el) => {
                            // @ts-ignore
                            return (!el.start || new Date(el.start) <= currentDate) && (!el.end || new Date(el.end) >= currentDate);
                        })?.length -
                    1
                }px)`}
                className="digi-banner-container-watch"
            >
                <div className="global-banner-text-container   ">
                    <h1 className={classNames("global-banner-title global-white", styles.bannerHeading)}>Turvaranneke</h1>
                    <p className="global-banner-text global-white">Napin painalluksella hälytys, puheyhteys ja paikannus.</p>
                    <Link to={localePath("osta", "turvaranneke")} style={{ marginTop: "auto" }}>
                        <Button secondary emphasized>
                            OSTA TURVARANNEKE
                        </Button>
                    </Link>
                </div>
            </Banner>
            <Container fluid className="my-3 services-container services-container-80" style={{ minWidth: "min(900px, 100%)" }}>
                <h1 className="services-header">Turvaranneke ja Digihappy palvelu - Teemme kaiken puolestasi</h1>
                <div className="global-box-line-container">
                    {services.map((service, key) => (
                        <div className="global-box-line" key={key}>
                            {key % 2 === 0 ? (
                                <React.Fragment>
                                    <div className="global-box global-background-gray">{service.content}</div>
                                    <div className={classNames("global-image-container", "global-credit-image-container")}>
                                        <img src={service.image} alt={service.alt} className={classNames("global-image", { "global-image-contain": service.contain ?? false })} />
                                        {service.credit && <span className="global-credit-text-right">{service.credit}</span>}
                                    </div>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <div className={classNames("global-image-container", "global-credit-image-container")}>
                                        <img src={service.image} alt={service.alt} className={classNames("global-image", { "global-image-contain": service.contain ?? false })} />
                                        {service.credit && <span className="global-credit-text">{service.credit}</span>}
                                    </div>
                                    <div className="global-box global-background-gray">{service.content}</div>
                                </React.Fragment>
                            )}
                        </div>
                    ))}
                </div>
            </Container>
            <Container fluid className="my-3 services-container service-table-container" id="palvelut">
                <div className="services-button-container">
                    <Button onClick={() => setPlay(1)}>Katso video</Button>
                    <div className="global-video-wrapper">
                        <iframe
                            src={`https://www.youtube.com/embed/PFzWQqfrVac?autoplay=${play}`}
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay"
                            allowFullScreen
                            title="Digihappy Senioritabletit"
                            style={{
                                margin: "0 auto",
                                width: "100%",
                                height: "100%",
                                border: "none",
                                aspectRatio: 16 / 9,
                            }}
                        />
                    </div>
                </div>
            </Container>
        </>
    );
};

export default Watch;
